function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import z from "zod";
import { defineDocument } from "sanity-typed-queries";
import { TaxonomyType } from "@stereoagency/constants";
import { arrayEntry, internationalizedArrayPageSections, internationalizedArraySimpleBlockContent, internationalizedArrayString, requiredImage, sanityReference, documentSlug } from "../fragments/index.js";
import profile from "./profile.js";
import taxonomy from "./taxonomy.js";
import researchGroup from "./researchGroup.js";
import researchPlatform from "./researchPlatform.js";
var schema = defineDocument("article", {
    slug: _object_spread({
        title: "Slug"
    }, documentSlug.factory()),
    title: {
        title: "Title",
        type: "internationalizedArrayString"
    },
    introduction: {
        title: "Introduction",
        type: "internationalizedArraySimpleBlockContent"
    },
    thumbnail: _object_spread({
        title: "Thumbnail"
    }, requiredImage.fragment),
    content: {
        title: "Content",
        type: "internationalizedArrayPageSections"
    },
    datetime: {
        title: "Datetime",
        type: "datetime",
        validation: function(Rule) {
            return Rule.required();
        }
    },
    timezone: {
        title: "Timezone",
        type: "string",
        description: "Leave blank to use the current timezone",
        options: {
            list: typeof Intl.supportedValuesOf !== "undefined" ? Intl.supportedValuesOf("timeZone") : []
        }
    },
    taxonomies: {
        title: "Taxonomies",
        description: "Supports NEWS category",
        type: "array",
        of: [
            {
                type: "reference",
                to: [
                    {
                        type: "taxonomy"
                    }
                ],
                options: {
                    filter: "type in $types",
                    filterParams: {
                        types: [
                            TaxonomyType.NEWS_CATEGORY
                        ]
                    }
                }
            }
        ]
    },
    linkedResearchContent: {
        title: "Research groups and platforms",
        type: "array",
        of: [
            {
                type: "reference",
                to: [
                    {
                        type: "researchGroup"
                    },
                    {
                        type: "researchPlatform"
                    }
                ]
            }
        ]
    }
}, [
    profile.schema.profile,
    taxonomy.schema.taxonomy,
    researchGroup.schema.researchGroup,
    researchPlatform.schema.researchPlatform,
    {},
    {},
    {}
]);
var validator = z.object({
    slug: documentSlug.validator,
    title: internationalizedArrayString.validator,
    introduction: internationalizedArraySimpleBlockContent.validator,
    thumbnail: requiredImage.validator,
    content: internationalizedArrayPageSections.validator,
    datetime: z.string(),
    timezone: z.string(),
    taxonomies: z.array(sanityReference.validator.merge(arrayEntry.validator)),
    linkedResearchContent: z.array(sanityReference.validator.merge(arrayEntry.validator))
}).partial();
schema.article;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=article.js.map